<template>
  <button
    type="button"
    class="btn btn-primary block m-b"
    :class="{ 'full-width': full }"
    @click="onClickButton"
    :disabled="loading"
    :style="{ color: textBlack ? 'black' : '' }"
  >
    <i class="fas fa-circle-notch fa-spin" v-if="loading"></i>
    <slot v-if="!loading"></slot>
  </button>
</template>

<script>
export default {
  name: "LoaderButton",
  props: {
    full: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    textBlack: {
      type: Boolean,
      default: () => true,
    },
  },
  methods: {
    onClickButton(e) {
      this.$el.blur();
      // Cancela o loading manualmente
      // const doneFn = () => (this.loading = false)
      // this.$emit('click', e, doneFn)
      this.$emit("click", e);
    },
  },
};
</script>
